import { render, staticRenderFns } from "./selectedTalents.vue?vue&type=template&id=070b5436"
import script from "./selectedTalents.vue?vue&type=script&lang=js"
export * from "./selectedTalents.vue?vue&type=script&lang=js"
import style0 from "./selectedTalents.vue?vue&type=style&index=0&id=070b5436&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports